import PropTypes from 'prop-types'
import { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import DeviceMetricsDoughnutChart from '@/pages/SpaceAnalyticsPage/charts/DeviceMetricsDoughnutChart'
import messages from '@/pages/SpaceAnalyticsPage/DeviceMetricsSection/messages'
import pageMessages from '@/pages/SpaceAnalyticsPage/messages'

const CHART_COLORS = ['#26beac', '#dd3f67', '#fcd145', '#5545b1', '#2bb2e3']

class MemberActivityByOS extends Component<any, any> {
  static displayName = 'MemberActivityByOS'

  static propTypes = {
    byOSData: PropTypes.array.isRequired
  }

  render() {
    const { byOSData } = this.props

    return (
      <div className="sub-section">
        <div className="metric-card-subheader">
          <h3>
            <FormattedMessage {...messages.memberActivityByOSTitle} />
          </h3>
          <span className="sub-text">
            <FormattedMessage {...messages.memberActivityByOSDescription} />
          </span>
        </div>
        {byOSData.length > 0 ? (
          <DeviceMetricsDoughnutChart data={byOSData} colors={CHART_COLORS} />
        ) : (
          <p className="flex-center">
            <FormattedMessage {...pageMessages.noActivityMetrics} />
          </p>
        )}
      </div>
    )
  }
}

export default MemberActivityByOS
